export const publicMeetingUrl = '/meet/j';

export const joinMeeting = (session) => `/meet/j/${session.iid}`;
